/* unplugin-vue-components disabled */import script from "./forum.vue?vue&type=script&setup=true&lang=js"
export * from "./forum.vue?vue&type=script&setup=true&lang=js"

import "./forum.vue?vue&type=style&index=0&id=56eb2f26&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56eb2f26"]])

export default __exports__